'use client';

import { cn } from '@app/ui/_lib/utils';
import { Container } from '../Container';
import { Text } from '../Text';
import { FormBlock, FormBlockProps } from '../FormBlock';
import { TextSectionBlock, TextSectionBlockProps } from '../TextSectionBlock';
import { SanityImage } from '../types';
import { Media } from '../Media';

export type FormHeroProps = {
	className?: string;
	image?: SanityImage;
	video?: string;
	textSectionBlock?: Omit<TextSectionBlockProps, 'size'>;
	form?: Omit<FormBlockProps, 'className'> & { formTitle?: string };
	backgroundImage?: SanityImage;
	backgroundVideo?: string;
};

export function FormHero(props: FormHeroProps) {
	return (
		<section className={cn('bg-background-primary relative z-50', props.className)} data-component='FormHero'>
			{(props.backgroundImage || props.backgroundVideo) && (
				<div className={`absolute top-0 left-0 w-full pointer-events-none`}>
					<Media className={`aspect-video [&_img]:h-full`} image={props.backgroundImage} video={props.backgroundVideo} priority />
					<div className={`w-full absolute top-0 left-0 bottom-0 bg-gradient-to-b from-background-primary/10 to-background-primary z-30`} />
				</div>
			)}

			<Container className='z-40 relative grid gap-responsive-2xl lg:grid-cols-[minmax(0,55fr)_minmax(0,45fr)]'>
				<div className='flex flex-col gap-8 lg:p-16'>
					{props.image && (
						<Media
							className='aspect-video rounded-lg overflow-hidden [&_img]:h-full h-fit md:h-auto lg:w-1/2'
							image={props.image}
							video={props.video}
							priority
						/>
					)}

					{props.textSectionBlock && <TextSectionBlock size={'lg'} {...props.textSectionBlock} />}
				</div>

				{props.form && (
					<div
						className='flex flex-col gap-8 rounded-lg bg-background-white p-spacing-md lg:p-spacing-xl'
						data-theme='light'
						data-header-ignore
					>
						{props.form.formTitle && (
							<>
								<Text as='h2' styleType='heading-2xs'>
									{props.form.formTitle}
								</Text>

								<div className='bg-border-primary h-px w-full' />
							</>
						)}

						<FormBlock {...props.form} />
					</div>
				)}
			</Container>
		</section>
	);
}
